module.exports = __webpack_public_path__ + "static/media/hero-home-1.24348009.png";